import { EEnvironment, type TEnvironment } from '@/entities';
import { ToolbarStorage } from '@/features/dev-toolbar';
import { isDevBuildMode } from '#shared/helpers/buildMode';

interface IBaseUrlOptions {
  baseUrlEnvKey: string;
}

const DEFAULT_ENVIRONMENT = EEnvironment.DEVELOPMENT;

// Перенес без изменений
export class BaseUrlController {
  #URLsMap = new Map<string, string>();
  #baseUrlEnvKey: string;

  constructor(options: IBaseUrlOptions) {
    this.#baseUrlEnvKey = options.baseUrlEnvKey;
  }

  private getApiUrlFromEnv(): string {
    return String(import.meta.env[this.#baseUrlEnvKey]);
  }

  public getBaseUrl(): string {
    const isDev = isDevBuildMode();
    const restEnvStore = ToolbarStorage.getStorageToolbarField('restEnv');

    if (isDev && this.#URLsMap.get(restEnvStore as string)) {
      return this.#URLsMap.get(restEnvStore as string) || '';
    }

    const hasApiUrl = this.getApiUrlFromEnv() && this.getApiUrlFromEnv() !== 'undefined';

    return hasApiUrl
      ? this.getApiUrlFromEnv() || ''
      : this.#URLsMap.get(import.meta.env.VITE_APP_MM_BUILD_MODE) ||
          this.#URLsMap.get(DEFAULT_ENVIRONMENT) ||
          '';
  }

  public add(environment: TEnvironment, url: string) {
    this.#URLsMap.set(environment, url);
  }
}
